module.exports = __webpack_public_path__ + "static/img/uelectroiconred.63122b7e.png";